// @flow
import Href from "../../models/href/Href";

import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useContent' instead
 */
export const connectContentDetailSection: ModularUIConnector = modularui(
  "ContentDetailSection",
  ({ sectioncontent, section, entryDate }) =>
    new Href(
      `/content/${decodeURIComponent(sectioncontent)}/${section}`,
    ).addParameter("entryDate", entryDate),
  { propName: "content" },
);
